import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
export const cameraFailedToReadBarcodeError = (error: unknown) => {
  reportMessageToSentry("Camera: Barcode detection failed", {
    level: "error",
    extra: {
      errorMessage: JSON.stringify(error),
    },
  });
};
